/*
 * @Description:
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-03 09:35:44
 * @LastEditors: zhangle
 * @LastEditTime: 2024-01-30 17:32:06
 */
import qs from 'qs'
/**
 * 请求统一管理
 */
import Request from '@/common/copyright/request';
// 分页查询剧集作品草稿列表
export const draftSearchApi = (data) => Request.post('drama/api/dramaDraft/search', data);

// 根据剧集作品ID查询剧集阶段列表
export const draftFindDramaStageDraftListApi = (dramaDraftId) => Request.get(`drama/api/dramaDraft/findDramaStageDraftList/${dramaDraftId}`);

// 根据最后一个剧集证据作品ID查询剧集作品
export const draftFindStageFilesApi = (data) => Request.post(`drama/api/dramaDraft/findStageFiles`, data);

// 根据ID查询剧集作品草稿
export const draftDetailApi = (id) => Request.get(`drama/api/dramaDraft/${id}`);

// 批量删除剧集作品草稿
export const draftDeleteApi = (data) => Request.delete(`drama/api/dramaDraft?${qs.stringify(data, { indices: false })}`, null, {
    customCode: 'system'
})

// 草稿数量
export const draftCountApi = (param) => Request.get(`drama/api/dramaDraft/count`, param);

// 第三步展示全部
export const draftThirdStepApi = (id) => Request.get(`drama/api/dramaDraft/info/${id}`);

// 申请版权认证证书
export const draftApplyApi = (data) => Request.post(`/api/opus/dramaOpus/dramaDraft/apply`, data,{
    network400: 'custom400'
});

